var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #112f72;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M719.4,25.1H79.8c-30,0-54.3,24.1-54.7,54v641.8c.4,29.9,24.7,54,54.7,54h640.3c30,0,54.4-24.1,54.9-54h0V79.1c-.5-29.9-24.8-54-54.9-54h-.7.1ZM247.5,664.1h-111.3v-357.8h111.3v357.8ZM191.8,257.3c-35.6,0-64.5-28.9-64.5-64.5s28.9-64.5,64.5-64.5,64.5,28.9,64.5,64.5h0c0,35.7-28.9,64.5-64.4,64.5h0,0ZM663.9,664.1h-111v-174c0-41.5-.9-94.9-57.8-94.9s-66.7,45.1-66.7,91.8v177h-111v-357.8h106.7v48.8h1.5c20.7-34.9,58.2-57.9,101-57.9s3,0,4.5,0h-.2c112.5,0,133.3,74,133.3,170.4v196.4h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSvgrepoCom);
export default __webpack_public_path__ + "static/media/linkedin-svgrepo-com.3aa6d9fc25d55980535636898a37c0b9.svg";
export { ForwardRef as ReactComponent };